

export default function maskSensitiveInfo(str) {
    if(str)
        return str = str.replaceAll(/[0-9]/ig, '*');
    else
        return str
}
